import { Utilities, type Catalog } from 'core/domains';
import { selectors as cartSelectors } from 'core/use-cases/cart';
import { getProductCartItem } from 'core/use-cases/helpers/';
import { selectors as userSelectors } from 'core/use-cases/user';
import { useSelector, type SelectorReturnFn } from 'core/use-cases/utilities';

export function useCycleGuidesSelector(): Catalog['cycleGuides'] {
  return useSelector((state) => state.catalog.cycleGuides);
}

export function useCatalogSelector(): SelectorReturnFn<Catalog['data']> {
  const { data, status, updatedAt = 0 } = useSelector((state) => state.catalog);
  const { data: cartData, status: cartStatus } = cartSelectors.useCartSelector();
  const itemAddCartError = userSelectors.useItemAddCartErrorSelector();

  if (cartStatus !== Utilities.STATUS.SUCCESS) {
    return {
      data,
      status,
      updatedAt,
    };
  }

  const catalogData = data.map((catalogItem) => {
    const { productPosition, productOrigin, quantity } = getProductCartItem(
      catalogItem.productCode,
      cartData,
    );

    return {
      ...catalogItem,
      productOrigin,
      productPosition,
      quantity,
      isAvailable: itemAddCartError?.includes(catalogItem.productCode)
        ? false
        : catalogItem.isAvailable,
    };
  });

  return {
    data: catalogData,
    status,
    updatedAt,
  };
}

export function usePaginationSelector(): SelectorReturnFn<Catalog['pagination']['data']> {
  const {
    pagination: { data, status, updatedAt = 0 },
  } = useSelector((state) => state.catalog);

  return {
    data,
    status,
    updatedAt,
  };
}

export function useQueryOptionsSelector(): Catalog['queryOptions'] {
  const { queryOptions } = useSelector((state) => state.catalog);

  return queryOptions;
}

export function useNotFoundSelector(): Catalog['notFound'] {
  const { notFound } = useSelector((state) => state.catalog);

  return notFound;
}
